export default [
  {
    path: "/managment/absofflineschedule",
    name: "absofflineschedule",
    component: () => import("@/views/managment/absofflineschedule/index.vue"),
    meta: {
      pageTitle: "AbsOfflineSchedule",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "AbsOfflineSchedule",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/absofflineschedule/edit/id=:id",
    name: "EditAbsOfflineSchedule",
    component: () => import("@/views/managment/absofflineschedule/edit.vue"),
    meta: {
      pageTitle: "EditAbsOfflineSchedule",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "EditAbsOfflineSchedule",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/absofflineaccountpattern",
    name: "absofflineaccountpattern",
    component: () => import("@/views/managment/absofflineaccountpattern/index.vue"),
    meta: {
      pageTitle: "AbsOfflineAccountPattern",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "AbsOfflineAccountPattern",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/absofflineaccountpattern/edit/id=:id",
    name: "EditAbsOfflineAccountPattern",
    component: () => import("@/views/managment/absofflineaccountpattern/edit.vue"),
    meta: {
      pageTitle: "EditAbsOfflineAccountPattern",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "EditAbsOfflineAccountPattern",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/organization",
    name: "organization",
    component: () => import("@/views/managment/organization/index.vue"),
    meta: {
      pageTitle: "Organization",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "Organization",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/organization/edit/id=:id",
    name: "EditOrganization",
    component: () => import("@/views/managment/organization/edit.vue"),
    meta: {
      pageTitle: "EditOrganization",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "EditOrganization",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/user",
    name: "user",
    component: () => import("@/views/managment/user/index.vue"),
    meta: {
      pageTitle: "User",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "User",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/user/edit/id=:id",
    name: "EditUser",
    component: () => import("@/views/managment/user/edit.vue"),
    meta: {
      pageTitle: "EditUser",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "EditUser",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/user/editesp/id=:id",
    name: "EditEspUser",
    component: () => import("@/views/managment/user/editesp.vue"),
    meta: {
      pageTitle: "EditUser",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "EditUser",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/role",
    name: "role",
    component: () => import("@/views/managment/role/index.vue"),
    meta: {
      pageTitle: "Role",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "Role",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/role/edit/id=:id",
    name: "EditRole",
    component: () => import("@/views/managment/role/edit.vue"),
    meta: {
      pageTitle: "EditRole",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "Role",
          active: true,
        },
        {
          text: "EditRole",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/settings",
    name: "settings",
    component: () => import("@/views/managment/settings/index.vue"),
    meta: {
      pageTitle: "Settings",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "Settings",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/table",
    name: "table",
    component: () => import("@/views/managment/table/index.vue"),
    meta: {
      pageTitle: "Table",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "Table",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/table/edit/id=:id",
    name: "EditTable",
    component: () => import("@/views/managment/table/edit.vue"),
    meta: {
      pageTitle: "Table",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "Table",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/appointmentemployee",
    name: "appointmentemployee",
    component: () => import("@/views/managment/appointmentemployee/index.vue"),
    meta: {
      pageTitle: "AppointmentEmployee",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "AppointmentEmployee",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/appointmentemployee/edit/id=:id",
    name: "EditAppointmentEmployee",
    component: () => import("@/views/managment/appointmentemployee/edit.vue"),
    meta: {
      pageTitle: "AppointmentEmployee",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "AppointmentEmployee",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/appointmentemployee/view/id=:id",
    name: "ViewAppointmentEmployee",
    component: () => import("@/views/managment/appointmentemployee/view.vue"),
    meta: {
      pageTitle: "AppointmentEmployee",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "AppointmentEmployee",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/uitranslate",
    name: "uitranslate",
    component: () => import("@/views/managment/uitranslate/index.vue"),
    meta: {
      pageTitle: "UITranslate",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "UITranslate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/faq",
    name: "faq",
    component: () => import("@/views/managment/faq/index.vue"),
    meta: {
      pageTitle: "FAQ",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "FAQ",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/payment-setting",
    name: "payment-setting",
    component: () => import("@/views/managment/paymentSetting/index.vue"),
    meta: {
      pageTitle: "PaymentSetting",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "PaymentSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/position-setting",
    name: "position-setting",
    component: () => import("@/views/managment/positionSetting/index.vue"),
    meta: {
      pageTitle: "PositionSetting",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "PositionSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/position-setting/edit/id=:id",
    name: "EditPositionSetting",
    component: () => import("@/views/managment/positionSetting/edit.vue"),
    meta: {
      pageTitle: "EditPositionSetting",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "PositionSetting",
          active: true,
        },
        {
          text: "EditPositionSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/docker",
    name: "docker",
    component: () => import("@/views/managment/docker/index.vue"),
    meta: {
      pageTitle: "Docker",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "Docker",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/usermanagesetting",
    name: "usermanagesetting",
    component: () => import("@/views/managment/usermanagesetting/index.vue"),
    meta: {
      pageTitle: "UserManageSetting",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "UserManageSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/usermanagesetting/view/id=:id",
    name: "ViewUserManageSetting",
    component: () => import("@/views/managment/usermanagesetting/view.vue"),
    meta: {
      pageTitle: "ViewUserManageSetting",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "UserManageSetting",
          active: true,
        },
        {
          text: "ViewUserManageSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/managment/usermanagesetting/edit/id=:id",
    name: "EditUserManageSetting",
    component: () => import("@/views/managment/usermanagesetting/edit.vue"),
    meta: {
      pageTitle: "EditUserManageSetting",
      breadcrumb: [
        {
          text: "Management",
        },
        {
          text: "UserManageSetting",
          active: true,
        },
        {
          text: "EditUserManageSetting",
          active: true,
        },
      ],
    },
  },
]
